import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export function NativeScrollReset() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (window.location.protocol !== "capacitor:") return;
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => { window.history.scrollRestoration = previous; };
  }, []);

  useLayoutEffect(() => {
    if (window.location.protocol !== "capacitor:") return;
    document.activeElement?.blur?.();
    const reset = () => window.scrollTo(0, 0);
    reset();
    const frame = window.requestAnimationFrame(reset);
    const timer = window.setTimeout(reset, 250);
    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(timer);
    };
  }, [pathname]);

  return null;
}


export function resetNativeScrollAfterSignIn() {
  if (window.location.protocol !== "capacitor:") return;
  document.activeElement?.blur?.();
  window.scrollTo(0, 0);
  const timer = window.setTimeout(() => window.scrollTo(0, 0), 250);
  return () => window.clearTimeout(timer);
}
